export default __webpack_public_path__ + "static/media/SN2-2.00c90797.jpg";